import { ModelHelper } from '../classes/model-helper';

export class LabProfileRestorationType {
	uid: string;
	name: string;
	displayName: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns LabProfileRestorationType
	 */
	static map(data: any, item: LabProfileRestorationType = new LabProfileRestorationType()): LabProfileRestorationType {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return LabProfileRestorationType
	 */
	public map(data: any): LabProfileRestorationType {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'displayName');

		// When display name is missing
		if (data['name'] && !this.displayName) {
			ModelHelper.map(data, this, 'displayName', null, 'name');
		}

		return this;
	}
}
